import {
  CustomRequestHeaderUnion,
  PkceAuthorizationCodeFlowHeader,
  PkceTokenRefreshRequestPayload,
  PkceTokenRequestPayload,
  PkceTokenResponse,
} from '@blk/aw-bff-typescript-models';
import { AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';
import { generateRequestConfig } from '../../utils/CloakDataUtils';
import { awSensitiveDataApi } from './Base';

export function postPkceToken(
  payload: PkceTokenRequestPayload,
  url: string,
  customHeaders: CustomRequestHeaderUnion[],
  cancelToken?: CancelToken
): Promise<AxiosResponse<PkceTokenResponse>> {
  let config: AxiosRequestConfig = generateRequestConfig({}, customHeaders);
  const pkceHeaderConfig: PkceAuthorizationCodeFlowHeader | undefined = customHeaders.find(
    (header) => header.type === 'pkceAuthorizationCodeFlow'
  );
  const disableWithCredentials = pkceHeaderConfig?.tokenWorkflowConfiguration.disableWithCredentials ?? false;

  config = {
    ...config,
    withCredentials: !disableWithCredentials,
    headers: {
      ...config.headers,
      // Reference: https://datatracker.ietf.org/doc/html/rfc6749#section-4.1.3
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  };
  return awSensitiveDataApi.post<PkceTokenResponse>(url, payload, { ...config, cancelToken });
}

export function postPkceTokenRefresh(
  payload: PkceTokenRefreshRequestPayload,
  url: string,
  customHeaders: CustomRequestHeaderUnion[],
  cancelToken?: CancelToken
): Promise<AxiosResponse<PkceTokenResponse>> {
  let config: AxiosRequestConfig = generateRequestConfig({}, customHeaders);
  const pkceHeaderConfig: PkceAuthorizationCodeFlowHeader | undefined = customHeaders.find(
    (header) => header.type === 'pkceAuthorizationCodeFlow'
  );
  const disableWithCredentials = pkceHeaderConfig?.tokenWorkflowConfiguration.disableWithCredentials ?? false;

  config = {
    ...config,
    withCredentials: !disableWithCredentials,
    headers: {
      ...config.headers,
      // Reference: https://datatracker.ietf.org/doc/html/rfc6749#section-4.1.3
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  };
  return awSensitiveDataApi.post<PkceTokenResponse>(url, payload, { ...config, cancelToken });
}
